import styled from 'styled-components';

import { Chip as MUIChip } from '@material-ui/core';
import { Skeleton as MUISkeleton } from '@material-ui/lab';
import { withStyles } from '@material-ui/styles';

export const InitialMessageContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  gap: 1rem;

  &[data-is-fullscreen='true'] {
    height: 100%;
    justify-content: space-between;

    .content {
      height: 100%;
    }

    .options {
      flex-direction: row;
      flex-wrap: wrap;
    }
  }
`;

export const InitialMessage = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  font-size: 1rem;
  text-align: center;
  line-height: 1.75rem;
  padding: 0 2rem;

  p {
    margin: 0;
  }

  strong {
    font-family: 'Poppins Bold';
  }
`;

export const Avatar = styled('div')`
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  margin-bottom: 1rem;
  background-color: #e0f3f1;

  svg {
    fill: #00b2a9;
  }
`;

export const InitialMessageOptions = styled('ul')`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const Option = withStyles({
  root: {
    fontFamily: "'Poppins Medium'",
    fontSize: '0.75rem',
    color: '#333',
    width: '100%',
    height: 'auto',
    minHeight: '40px',
    textAlign: 'left',
    lineHeight: '1.25rem',
    padding: '0.5rem 0.25rem',
    justifyContent: 'start',
    '& > .MuiChip-label': {
      whiteSpace: 'normal',
    },
  },
})(MUIChip);

export const LoadingMessages = withStyles({
  root: {
    marginBottom: '0.5rem',
  },
})(MUISkeleton);
